import i18n from "../locales/i18n";
// Define the type for onboarding data
type onboardingSwiperDataType = {
  id: number;
  title: string;
  description: string;
  image: number;
};

export const onboardingSwiperData: onboardingSwiperDataType[] = [
  {
    id: 1,
    title: i18n.t("welcomeTitle"),
    description: i18n.t("welcomeDescription"),
    image: require("../assets/welcome-screen/welcome-swiper-1.png"),
  },
  {
    id: 2,
    title: i18n.t("scannerTitle"),
    description: i18n.t("scannerDescription"),
    image: require("../assets/welcome-screen/welcome-swiper-2.png"),
  },
  {
    id: 3,
    title: i18n.t("inventoryTitle"),
    description: i18n.t("inventoryDescription"),
    image: require("../assets/welcome-screen/welcome-swiper-3.png"),
  },
];
